/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Component} from 'react';

class Scale extends Component {

  changeSelected = (event) => {
    const {label, onClick, row} = this.props;
    onClick(label, row, event)
  }

  convertToLabel(scale) {
    let scaleToLabel = '';
    switch (scale) {
      case '1:2.500':
        scaleToLabel = '2.5K';
        break;
      case '1:5.000':
        scaleToLabel = '5K';
        break;
      case '1:10.000':
        scaleToLabel = '10K';
        break;
      case '1:25.000':
        scaleToLabel = '25K';
        break;
      case '1:20.000':
        scaleToLabel = '20K';
        break;
      case '1:30.000':
        scaleToLabel = '30K';
        break;
      case '1:40.000':
        scaleToLabel = '40K';
        break;
      case '1:50.000':
        scaleToLabel = '50K';
        break;
      case '1:60.000':
        scaleToLabel = '60K';
        break;
      default:
        scaleToLabel = '2.5K';
    }

    return scaleToLabel;
  }

  render() {
    const {
      className,
      classNameActive,
      label,
      selected,
      tooltipText,
      scale
    } = this.props;

    const activeClass = selected === label && label === this.convertToLabel(scale)
      ? classNameActive
      : className;

    return (<a href="#" className={activeClass} onClick={this.changeSelected}>
      <div className="tooltip">A
        <span className="tooltiptext">
          {tooltipText}
        </span>
      </div>
      <label>{label}</label>
    </a>);
  }
}

export default Scale;
